<n-slide-window *ngIf="pageReady" [visible]="windowVisible" [width]="isSimpleMode ? '6.08rem' : '7rem'" (onHide)="close()">
    <n-header>
        <h1>{{ i18n.title.modifyClient}}</h1>
        <n-help-link key="cifsModifyUser" *ngIf = "!isSimpleMode"></n-help-link>
        <n-help-link key="simplifycifsManage" *ngIf="isSimpleMode"></n-help-link>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="isSimpleMode"
            [ngClass]="{ 'form-width-simple': isSimpleMode, 'common-form': !isSimpleMode }">
        <!-- 类型  不允许修改，只展示-->
        <n-form-item [label]="i18n.label.type">
            {{str.getUpperCaseUserOrGroupType | fn :data}}
        </n-form-item>

        <n-form-item  [label]="i18n.label.name">
            {{ prefixHandler | fn :data.NAME }}
        </n-form-item>

        <!-- 权限级别 -->
        <n-form-item [label]="i18n.label.permissionLevel">
            <n-select id="modify-client-cifs-share_permission_dropdown" formControlName="permission"
                [options]="entry === FileSystemEntryE.AuditLog && !(this.fileSystem?.isAuditLogFs && this.fileSystem?.auditLogWritable) ? str.auditLogFsPermissionLevelOpts : str.permissionLevelOpts">
            </n-select>
        </n-form-item>
    </form>

    <n-footer>
        <button id="modify-client-cifs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="modify-client-cifs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
